// 接入文档：https://ones.jlcops.com/wiki/#/team/NuJZZHo6/space/HYY4xxP3/page/XjB2GqEi
import { useContext } from 'react';

import { LayoutContext } from '../../baseLayout/provider';

import Utils from '@lcsc-ui/utils/Utils';

function renderCatalog(catalog, resourceData) {
  if (!catalog) return null;

  return (
    <ul>
      {catalog.sonCatalogList && catalog.sonCatalogList.length > 0 && (
        <>
          {catalog.sonCatalogList.map((child) => {
            const isMroSubCatalog =
              catalog.catalogName?.includes('工业品') || catalog.catalogName?.includes('仪器仪表');
            return (
              <li key={child.catalogId}>
                {isMroSubCatalog ? (
                  <a
                    href={`${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${child.mroCatalogId}.html`}
                    target="_blank"
                  >
                    {child.catalogName}
                  </a>
                ) : (
                  <a
                    href={`${resourceData.projectConfigVO.lcscListUrl}/catalog/${child.catalogId}.html`}
                    target="_blank"
                  >
                    {child.catalogName}
                  </a>
                )}
                {catalog.sonCatalogList && renderCatalog(child, resourceData)}
              </li>
            );
          })}
        </>
      )}
    </ul>
  );
}

export default function SeoCatalogsContent({ resourceData }) {
  const { catalogList } = useContext(LayoutContext);
  if (catalogList) {
    const gkdqTargetId = Utils.findFirstMroCatalogId(catalogList, '工控电气');

    return (
      <div className="sr-only">
        {Object.entries(catalogList).map(([key, value]) => (
          <div key={key}>
            {key.includes('工业品') || key.includes('仪器仪表') ? (
              <a
                data-title={key}
                href={
                  key.includes('仪器仪表') && gkdqTargetId
                    ? `${resourceData.projectConfigVO.lcscListUrl}/mro/catalog/${gkdqTargetId}.html`
                    : resourceData.projectConfigVO.lcscMroUrl
                }
                target="_blank"
              >
                {key}
              </a>
            ) : (
              <div data-title={key}>{key}</div>
            )}
            {renderCatalog(value, resourceData)}
          </div>
        ))}
      </div>
    );
  }

  return <div>暂无数据</div>;
}
